"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1388],{

/***/ 56769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ openAlertModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
// EXTERNAL MODULE: ./src/app.components/Modal/Modal.tsx + 1 modules
var Modal = __webpack_require__(7029);
// EXTERNAL MODULE: ./src/svgIcons/CloseOutlined.tsx
var CloseOutlined = __webpack_require__(57065);
;// CONCATENATED MODULE: ./src/app.components/modals/AlertModal/AlertModal.tsx






function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  z-index: 101;\n  background-color: #ffffff;\n\n  border-radius: 20px;\n  padding: 50px 30px;\n  min-height: 215px;\n  min-width: 360px;\n  width: fit-content;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  gap: 20px;\n  align-items: center;\n  text-align: center;\n\n  .close-btn {\n    cursor: pointer;\n    z-index: 100;\n    position: absolute;\n    top: 30px;\n    color: #999999;\n    right: 30px;\n  }\n  .confirm-message {\n    margin-top: 20px;\n    margin-bottom: 10px;\n    font-size: 18px;\n  }\n  .modal-button {\n    color: #ffffff;\n    padding: 12px 30px;\n    border-radius: 5px;\n    & > span {\n      font-size: 16px;\n      font-weight: 600;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var AlertModal = function(_param) {
    var _buttonText = _param.buttonText, buttonText = _buttonText === void 0 ? "확인" : _buttonText, message = _param.message, onConfirm = _param.onConfirm, onClose = _param.onClose, props = (0,_object_without_properties/* default */.Z)(_param, [
        "buttonText",
        "message",
        "onConfirm",
        "onClose"
    ]);
    var handleClose = function() {
        onClose && onClose();
    };
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = onConfirm;
                        if (!_tmp) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            onConfirm()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        _state.label = 2;
                    case 2:
                        _tmp;
                        handleClose();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var renderAlertMessage = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: message === null || message === void 0 ? void 0 : message.split("\n").map(function(line, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        line.trim(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                    ]
                }, index);
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClose: onClose
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "close-btn",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseOutlined/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "confirm-message",
                    children: renderAlertMessage()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "contained",
                    className: "modal-button",
                    onClick: handleConfirm,
                    children: buttonText
                })
            ]
        })
    }));
};
/* harmony default export */ var AlertModal_AlertModal = ((/* unused pure expression or super */ null && (AlertModal)));
var openAlertModal = (0,Modal/* createOpenModal */.S)(AlertModal);

var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AlertModal__StyledWrapper",
    componentId: "sc-a850ddfa-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/app.components/modals/AlertModal/index.ts



/***/ }),

/***/ 40532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SelfIntroduction_SelfIntroductionDetailModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.components/Modal/Modal.tsx + 1 modules
var Modal = __webpack_require__(7029);
// EXTERNAL MODULE: ./src/app.feature/coverletter/coverletter.write/libs/utils.tsx
var utils = __webpack_require__(30015);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/ExportButton/ExportList.module.tsx
var ExportList_module = __webpack_require__(90425);
// EXTERNAL MODULE: ./src/app.modules/hooks/useDropdown.tsx
var useDropdown = __webpack_require__(6714);
// EXTERNAL MODULE: ./src/svgIcons/Export.tsx
var Export = __webpack_require__(12315);
;// CONCATENATED MODULE: ./src/app.components/modals/SelfIntroduction/ExportButtonMobile.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex-shrink: 0;\n  .export-list {\n    padding: 15px 0;\n    position: absolute;\n    top: calc(100% + 10px);\n    right: 0;\n    border: 1px solid #ddd;\n    box-shadow: 3px 3px 3px 0 rgba(0, 0, 0, 0.15);\n    border-radius: 5px;\n    padding: 10px 0px;\n    white-space: nowrap;\n    font-size: 12px;\n    background-color: #fff;\n    .export-item {\n      font-size: 12px;\n      padding: 7px 14px;\n      :active {\n        color: #01a0ff;\n        background-color: #f4f4f4;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ExportButtonMobile = function(param) {
    var data = param.data;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useDropdown/* default */.Z)(), 3), menuRef = ref[0], isDropdownOpened = ref[1], toggleDropdown = ref[2];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        ref: menuRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Export/* default */.Z, {
                onClick: toggleDropdown
            }),
            isDropdownOpened && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "export-list",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "export-item",
                        onClick: function() {
                            return (0,ExportList_module/* exportDocx */.Yd)(data);
                        },
                        children: "워드(docx) 파일로 저장"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "export-item",
                        onClick: function() {
                            return (0,ExportList_module/* exportPdf */.dG)(data);
                        },
                        children: "PDF 파일로 저장"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "export-item",
                        onClick: function() {
                            return (0,ExportList_module/* exportTxt */._H)(data);
                        },
                        children: "텍스트(txt) 파일로 저장"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SelfIntroduction_ExportButtonMobile = (ExportButtonMobile);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ExportButtonMobile__StyledWrapper",
    componentId: "sc-205c92ab-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/app.components/modals/SelfIntroduction/SelfIntroductionDetailModal.tsx




function SelfIntroductionDetailModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment SelfIntroductionDetailModal_SelfIntroduction on SelfIntroduction {\n    id\n    title\n    activity {\n      id\n    }\n    qna {\n      id\n      question\n      answer\n      charSize\n      charMaxSize\n      blankType\n      seq\n    }\n    ...StoreSelfIntroduction_SelfIntroduction\n  }\n"
    ]);
    SelfIntroductionDetailModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 0 20px;\n  background-color: #fff;\n  .header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 50px;\n    span {\n      font-size: 16px;\n      font-weight: bold;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      padding: 0 30px;\n    }\n    svg {\n      width: 16px;\n      height: 16px;\n      flex-shrink: 0;\n    }\n  }\n  .noti {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 44px;\n    font-size: 14px;\n    font-weight: bold;\n    margin-top: 10px;\n    border-radius: 5px;\n    color: #01a0ff;\n    background-color: #f2faff;\n  }\n  .qna-list {\n    display: flex;\n    overflow-x: auto;\n    gap: 5px;\n    padding-top: 12px;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n    ::-webkit-scrollbar {\n      display: none;\n    }\n    .qna-num {\n      line-height: 1.43;\n      padding: 6px 12px 7px;\n      font-size: 12px;\n      font-weight: 500;\n      border-radius: 15px;\n      border: solid 1px #ccc;\n      &[data-active='true'] {\n        color: #fff;\n        font-weight: bold;\n        background-color: #01a0ff;\n        border-color: #01a0ff;\n      }\n    }\n  }\n  .question {\n    height: 66px;\n    padding: 12px 15px;\n    margin-top: 12px;\n    border-radius: 5px;\n    border: solid 1px #ccc;\n    font-size: 14px;\n    font-weight: 500;\n    overflow-y: auto;\n    &[data-empty='true'] {\n      color: #999;\n    }\n  }\n  .answer {\n    height: 357px;\n    margin-top: 12px;\n    padding: 12px 15px;\n    border-radius: 5px;\n    border: solid 1px #ccc;\n    font-size: 14px;\n    overflow-y: auto;\n    &[data-empty='true'] {\n      color: #999;\n    }\n  }\n  .footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 37px;\n    padding: 0 15px;\n    margin-top: 12px;\n    border-radius: 5px;\n    background-color: #f4f4f4;\n    font-size: 12px;\n    span {\n      color: #01a0ff;\n    }\n  }\n  .activity-btn {\n    display: flex;\n    align-items: center;\n    gap: 3px;\n\n    svg {\n      width: 8px;\n      height: 8px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










src_default()(SelfIntroductionDetailModal_templateObject());
var SelfIntroductionDetailModal = function(_param) {
    var data = _param.data, onClose = _param.onClose, props = (0,_object_without_properties/* default */.Z)(_param, [
        "data",
        "onClose"
    ]);
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)((ref = data.qna) === null || ref === void 0 ? void 0 : ref[0]), selectedQna = ref3[0], setSelectedQna = ref3[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClose: onClose,
        animation: "left"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelfIntroductionDetailModal_StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ArrowLeft */.Xd, {
                            onClick: onClose
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: data.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelfIntroduction_ExportButtonMobile, {
                            data: data
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "noti",
                    children: "자소서 작성 및 수정은 PC, 모바일 앱을 이용해주세요."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "qna-list",
                    children: (ref1 = data.qna) === null || ref1 === void 0 ? void 0 : ref1.map(function(qna) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("button", {
                            className: "qna-num",
                            "data-active": qna.id === (selectedQna === null || selectedQna === void 0 ? void 0 : selectedQna.id),
                            onClick: function() {
                                return setSelectedQna(qna);
                            },
                            children: String(qna.seq).padStart(2, "0")
                        }, qna.id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "question",
                    "data-empty": !(selectedQna === null || selectedQna === void 0 ? void 0 : selectedQna.question),
                    children: (selectedQna === null || selectedQna === void 0 ? void 0 : selectedQna.question) || "입력한 자기소개서 질문이 없습니다."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "answer",
                    "data-empty": !(selectedQna === null || selectedQna === void 0 ? void 0 : selectedQna.answer),
                    children: (selectedQna === null || selectedQna === void 0 ? void 0 : selectedQna.answer) || "입력한 자기소개서 내용이 없습니다."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "footer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: selectedQna === null || selectedQna === void 0 ? void 0 : (ref2 = selectedQna.answer) === null || ref2 === void 0 ? void 0 : ref2.length
                                }),
                                "/",
                                selectedQna === null || selectedQna === void 0 ? void 0 : selectedQna.charMaxSize,
                                (selectedQna === null || selectedQna === void 0 ? void 0 : selectedQna.charSize) === graphql/* CharSize.CHAR */.PS6.CHAR ? "자" : " bytes",
                                "(",
                                (0,utils/* formatBlankType */.St)((selectedQna === null || selectedQna === void 0 ? void 0 : selectedQna.blankType) || graphql/* BlankType.WITH_BLANK */.blf.WITH_BLANK),
                                ")"
                            ]
                        }),
                        data.activity && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/activity/".concat(data.activity.id),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "activity-btn",
                                children: [
                                    "공고보기",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ArrowRight */.ol, {})
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var SelfIntroduction_SelfIntroductionDetailModal = (SelfIntroductionDetailModal);
var SelfIntroductionDetailModal_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SelfIntroductionDetailModal__StyledWrapper",
    componentId: "sc-e247440-0"
})(_templateObject1());


/***/ }),

/***/ 72883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SelfIntroduction_SelfIntroductionSearchModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
// EXTERNAL MODULE: ./src/app.components/Modal/Modal.tsx + 1 modules
var Modal = __webpack_require__(7029);
// EXTERNAL MODULE: ./src/app.components/inputs/TextField.tsx
var TextField = __webpack_require__(45800);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/LoadModal/components/SearchResultList/SearchResultNotFound.tsx
var SearchResultNotFound = __webpack_require__(63477);
// EXTERNAL MODULE: ./src/components/BounceLoading.tsx
var BounceLoading = __webpack_require__(14609);
// EXTERNAL MODULE: ./src/app.feature/coverletter/coverletter.manage/component/FileItemMobile.tsx
var FileItemMobile = __webpack_require__(51049);
;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.manage/component/SelfIntroductionSearchResult.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .loading-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    height: 100%;\n    .loading {\n      margin-bottom: 30px;\n    }\n    .loading-text {\n      font-size: 14px;\n      font-weight: 500;\n      color: #999;\n      text-align: center;\n    }\n  }\n  .total-count {\n    height: 50px;\n    padding: 22px 20px 0;\n    font-size: 12px;\n    color: #999;\n  }\n  .file-item {\n    background-color: #fff;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var SelfIntroductionSearchResult = function() {
    var router = (0,next_router.useRouter)();
    var query = (0,react.useMemo)(function() {
        return "".concat(router.query.q || "");
    }, [
        router.query
    ]);
    var ref = (0,graphql/* useGqlSelfIntroductionInfosQuery */.j6c)({
        variables: {
            filterBy: {
                type: null,
                keyword: query
            },
            pagination: {
                page: 1,
                pageSize: 1000
            }
        }
    }), data = ref.data, loading = ref.loading;
    if (!query) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "total-count",
                children: [
                    "자기소개서 검색 ",
                    data === null || data === void 0 ? void 0 : data.selfIntroductionInfos.totalCount,
                    "건"
                ]
            }),
            (loading || !data) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "loading-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BounceLoading/* default */.Z, {
                        className: "loading"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "loading-text",
                        children: "자기소개서를 불러오고 있습니다."
                    })
                ]
            }),
            (data === null || data === void 0 ? void 0 : data.selfIntroductionInfos.nodes.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultNotFound/* default */.Z, {
                searchKeyword: query
            }),
            data === null || data === void 0 ? void 0 : data.selfIntroductionInfos.nodes.map(function(node) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "file-item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FileItemMobile/* default */.Z, {
                        data: node.selfIntroduction,
                        keyword: query
                    })
                }, "SearchResultList-".concat(node.id));
            })
        ]
    });
};
/* harmony default export */ var component_SelfIntroductionSearchResult = (SelfIntroductionSearchResult);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SelfIntroductionSearchResult__StyledWrapper",
    componentId: "sc-d53bb059-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/app.components/modals/AlertModal/index.ts + 1 modules
var AlertModal = __webpack_require__(56769);
;// CONCATENATED MODULE: ./src/app.components/modals/SelfIntroduction/SelfIntroductionSearchModal.tsx




function SelfIntroductionSearchModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow-y: auto;\n  background-color: #fafafa;\n  .sticky {\n    position: sticky;\n    top: 0;\n  }\n  .header {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 50px;\n    font-size: 16px;\n    font-weight: bold;\n    background-color: #fff;\n    .arrow-left {\n      position: absolute;\n      left: 20px;\n      font-size: 16px;\n    }\n  }\n  .search-content {\n    padding: 10px 20px;\n    background-color: #fff;\n    border-bottom: 1px solid #e8e8e8;\n    .search-input-wrapper {\n      padding: 8px 15px;\n      display: flex;\n      gap: 7px;\n      align-items: center;\n      background-color: #f4f4f4;\n      border-radius: 5px;\n      svg {\n        width: 16px;\n        height: 16px;\n      }\n      .close {\n        font-size: 10px;\n      }\n      .search-input {\n        background-color: transparent;\n        padding: 0px;\n        border: none;\n        font-size: 16px;\n        outline: none;\n        border-radius: 0;\n        &::placeholder {\n          color: #bbb;\n        }\n      }\n    }\n  }\n"
    ]);
    SelfIntroductionSearchModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var SelfIntroductionSearchModal = function(_param) {
    var onClose = _param.onClose, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onClose"
    ]);
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), input = ref[0], setInput = ref[1];
    var inputRef = (0,react.useRef)(null);
    var query = (0,react.useMemo)(function() {
        return "".concat(router.query.q || "");
    }, [
        router.query
    ]);
    var handleSubmit = function(e) {
        var ref;
        e.preventDefault();
        (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.blur();
        if (input === "") return;
        if (input && input.trim().length < 2) {
            (0,AlertModal/* openAlertModal */.N)({
                open: true,
                message: "검색어는 2자 이상 입력하셔야합니다.",
                isModalOverlapping: true
            });
            return;
        }
        router.push({
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                back: router.query.back || router.asPath,
                q: input
            })
        });
    };
    (0,react.useEffect)(function() {
        setInput(query);
        if (query === "") {
            var ref;
            (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        } else {
            var ref1;
            (ref1 = inputRef.current) === null || ref1 === void 0 ? void 0 : ref1.blur();
        }
    }, [
        query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClose: onClose,
        animation: "left"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelfIntroductionSearchModal_StyledWrapper, {
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "sticky",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "header",
                            children: [
                                "자기소개서 검색",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ArrowLeft */.Xd, {
                                    className: "arrow-left",
                                    onClick: onClose
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "search-content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "search-input-wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* MagnifyingGlass */.Yt, {
                                        onClick: handleSubmit
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                        value: input,
                                        ref: inputRef,
                                        placeholder: "자기소개서 검색",
                                        className: "search-input",
                                        onChange: function(e) {
                                            return setInput(e.target.value);
                                        }
                                    }),
                                    input && /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {
                                        className: "close",
                                        onClick: function() {
                                            return setInput("");
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_SelfIntroductionSearchResult, {})
            ]
        })
    }));
};
/* harmony default export */ var SelfIntroduction_SelfIntroductionSearchModal = (SelfIntroductionSearchModal);
var SelfIntroductionSearchModal_StyledWrapper = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    displayName: "SelfIntroductionSearchModal__StyledWrapper",
    componentId: "sc-21eab9a2-0"
})(SelfIntroductionSearchModal_templateObject());


/***/ }),

/***/ 51049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44119);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(graphql_tag__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var interweave__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63108);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53893);
/* harmony import */ var _app_components_modals_SelfIntroduction_SelfIntroductionDetailModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40532);
/* harmony import */ var _app_feature_coverletter_coverletter_write_libs_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30015);
/* harmony import */ var hooks_useKeywordHighlighter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17683);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment FileItemMobile_SelfIntroduction on SelfIntroduction {\n    id\n    title\n    createdAt\n    deletedAt\n    activity {\n      id\n      recruitType\n      recruitCloseAt\n    }\n    ...SelfIntroductionDetailModal_SelfIntroduction\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 20px;\n  .item-wrapper {\n    display: flex;\n    align-items: center;\n    padding: 16px 0;\n    border-bottom: 1px solid #eee;\n    .note-icon {\n      margin-right: 12px;\n      flex-shrink: 0;\n    }\n    .file-info {\n      display: flex;\n      flex-direction: column;\n      gap: 2px;\n\n      .file-title {\n        width: 100%;\n        font-size: 16px;\n        font-weight: 500;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 2;\n\n        .highlight {\n          font-weight: bold;\n        }\n      }\n      .info-footer {\n        display: flex;\n        gap: 8px;\n        font-size: 12px;\n        .remain-time {\n          color: #ef2929;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









graphql_tag__WEBPACK_IMPORTED_MODULE_2___default()(_templateObject());
var FileItemMobile = function(param) {
    var data = param.data, keyword = param.keyword;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var handleOpenDetailModal = function() {
        router.push({
            query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, router.query), {
                id: data.id
            })
        }, undefined, {
            shallow: true
        });
    };
    var handleCloseDetailModal = function() {
        var query = router.query;
        delete query.id;
        router.push({
            query: query
        }, undefined, {
            shallow: true
        });
    };
    var title = (0,hooks_useKeywordHighlighter__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        text: data.title || "",
        keyword: keyword || ""
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "item-wrapper",
                onClick: handleOpenDetailModal,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_4__/* .Note */ .jC, {
                        className: "note-icon",
                        color: "#666"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "file-info",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "file-title",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(interweave__WEBPACK_IMPORTED_MODULE_10__/* .Interweave */ .wZ, {
                                    content: title
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "info-footer",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "item-date",
                                    children: (0,_app_feature_coverletter_coverletter_write_libs_utils__WEBPACK_IMPORTED_MODULE_6__/* .formatCreatedAt */ .Qg)(data.createdAt)
                                })
                            })
                        ]
                    })
                ]
            }),
            router.query.id === data.id && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_modals_SelfIntroduction_SelfIntroductionDetailModal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                open: true,
                onClose: handleCloseDetailModal,
                data: data
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FileItemMobile);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FileItemMobile__StyledWrapper",
    componentId: "sc-aafca7ac-0"
})(_templateObject1());


/***/ }),

/***/ 30015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qg": function() { return /* binding */ formatCreatedAt; },
/* harmony export */   "St": function() { return /* binding */ formatBlankType; },
/* harmony export */   "oD": function() { return /* binding */ formatCharMaxSize; },
/* harmony export */   "pn": function() { return /* binding */ formatDisplayedAt; },
/* harmony export */   "t1": function() { return /* binding */ getAnswerLength; }
/* harmony export */ });
/* unused harmony export getBytes */
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32912);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);


var getBytes = function(target) {
    var b, i, c;
    for(b = i = 0; c = target.charCodeAt(i++); b += c >> 11 ? 3 : c >> 7 ? 2 : 1);
    return b;
};
var TIME_ZONE = 3240 * 10000;
var formatCreatedAt = function(date) {
    try {
        var formattedCreatedAt = new Date(date + TIME_ZONE).toISOString().replace("T", " ").replace(/\..*/, "").slice(0, 16);
        return formattedCreatedAt;
    } catch (error) {
        return "-";
    }
};
var formatBlankType = function(data) {
    return data === generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .BlankType.WITH_BLANK */ .blf.WITH_BLANK ? "공백포함" : "공백제외";
};
var formatCharMaxSize = function(data) {
    if (data === generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CharSize.CHAR */ .PS6.CHAR) return "글자 수";
    if (data === generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CharSize.THREE_BYTE */ .PS6.THREE_BYTE) return "3byte";
    if (data === generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CharSize.TWO_BYTE */ .PS6.TWO_BYTE) return "2byte";
    return "";
};
var formatDisplayedAt = function(createdAt) {
    var formattedCreatedAt = (0,date_fns_format__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(createdAt, "yyyy.dd");
    var formattedNow = (0,date_fns_format__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(new Date(), "yyyy.dd");
    if (formattedCreatedAt === formattedNow) {
        return (0,date_fns_format__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(createdAt, "hh:mm");
    }
    var milliSeconds = new Date().getTime() - createdAt;
    var seconds = milliSeconds / 1000;
    if (seconds < 60) return "방금 전";
    var minutes = seconds / 60;
    if (minutes < 60) return "".concat(Math.floor(minutes), "분 전");
    var hours = minutes / 60;
    if (hours < 24) return "".concat(Math.floor(hours), "시간 전");
    var days = hours / 24;
    if (days < 7) return "".concat(Math.floor(days), "일 전");
    var weeks = days / 7;
    if (weeks < 5) return "".concat(Math.floor(weeks), "주 전");
    var months = days / 30;
    if (months < 12) return "".concat(Math.floor(months), "개월 전");
    var years = days / 365;
    return "".concat(Math.floor(years), "년 전");
};
var byteCounter = function(text, sum) {
    var byte = 0;
    for(var i = 0; i < text.length; i++){
        if (/[ㄱ-ㅎㅏ-ㅣ가-힣一-龥ぁ-ゔァ-ヴー々〆〤]/.test(text[i])) {
            byte = byte + sum;
        } else {
            byte++;
        }
    }
    return byte;
};
var getAnswerLength = function(answer, blankType, charSize) {
    if (blankType === generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .BlankType.WITH_BLANK */ .blf.WITH_BLANK) {
    //
    }
    if (blankType === generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .BlankType.WITHOUT_BLANK */ .blf.WITHOUT_BLANK) {
        answer = answer.replace(/(\s*)/g, "");
    }
    if (charSize === generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CharSize.CHAR */ .PS6.CHAR) {
        return answer.length;
    } else if (charSize === generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CharSize.TWO_BYTE */ .PS6.TWO_BYTE) {
        var bytes = byteCounter(answer, 2);
        return bytes;
    } else if (charSize === generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CharSize.THREE_BYTE */ .PS6.THREE_BYTE) {
        var bytes1 = byteCounter(answer, 3);
        return bytes1;
    }
    return 0;
};


/***/ }),

/***/ 90425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yd": function() { return /* binding */ exportDocx; },
/* harmony export */   "_H": function() { return /* binding */ exportTxt; },
/* harmony export */   "dG": function() { return /* binding */ exportPdf; },
/* harmony export */   "e_": function() { return /* binding */ printPdf; }
/* harmony export */ });
/* unused harmony export formatSelfIntroductionToText */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20414);
/* harmony import */ var docx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23050);
/* harmony import */ var docx__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(docx__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var jspdf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91819);
/* harmony import */ var _app_feature_coverletter_coverletter_write_libs_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30015);






// TODO: PDF 파일 포맷
// TODO: 사파리 인쇄하기
/** 자소서 포맷 변환 */ var formatSelfIntroductionToText = function(data) {
    if (!data.qna) return "";
    var qnaStrings = data.qna.map(function(qna) {
        var answerLength = (0,_app_feature_coverletter_coverletter_write_libs_utils__WEBPACK_IMPORTED_MODULE_2__/* .getAnswerLength */ .t1)(qna.answer || "", qna.blankType, qna.charSize);
        var blankType = (0,_app_feature_coverletter_coverletter_write_libs_utils__WEBPACK_IMPORTED_MODULE_2__/* .formatBlankType */ .St)(qna.blankType);
        var charSize = (0,_app_feature_coverletter_coverletter_write_libs_utils__WEBPACK_IMPORTED_MODULE_2__/* .formatCharMaxSize */ .oD)(qna.charSize);
        return "\n".concat(qna.seq, ". ").concat(qna.question, " ").concat(answerLength, "/").concat(qna.charMaxSize, "(").concat(charSize, ", ").concat(blankType, ")\n\n").concat(qna.answer, "\n");
    });
    var result = "\n".concat(data.title, "\n\n").concat(qnaStrings.join("\n\n"), "\n\n링커리어\n");
    return result;
};
var downloadBlob = function(blob, filename) {
    var url = URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.download = filename;
    link.href = url;
    link.click();
};
var exportTxt = function(data) {
    var fileData = formatSelfIntroductionToText(data);
    var utf8Bom = "\uFEFF" // UTF-8 BOM
    ;
    var content = utf8Bom + fileData;
    var blob = new Blob([
        content
    ], {
        type: "text/plain;charset=utf-8"
    });
    downloadBlob(blob, "".concat(data.title, "_링커리어.txt"));
};
var getSplittedLines = function(text, length) {
    var lineLength = Math.ceil(text.length / length);
    var lines = new Array(lineLength).fill("");
    lines.forEach(function(_, index) {
        lines[index] = text.slice(index * length, (index + 1) * length);
    });
    return lines;
};
var formatSelfintroductionToJsPDF = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(data) {
        var response, fontBlob, fontBase64, doc, lines, pages;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("/fonts/malgun.ttf")
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.blob()
                    ];
                case 2:
                    fontBlob = _state.sent();
                    return [
                        4,
                        blobToBase64(fontBlob)
                    ];
                case 3:
                    fontBase64 = _state.sent();
                    doc = new jspdf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP({
                        format: "a4"
                    });
                    doc.addFileToVFS("malgun.ttf", fontBase64);
                    doc.addFont("malgun.ttf", "malgun", "normal");
                    doc.setFont("malgun");
                    /*
  doc.addImage(
    'https://raw.githubusercontent.com/MrRio/jsPDF/master/examples/images/Octonyan.jpg',
    'JPEG',
    15,
    40,
    170,
    170,
  )
  */ if (!data.qna) return [
                        2,
                        doc
                    ];
                    lines = [];
                    doc.setFontSize(12);
                    //* 자기소개서 제목
                    lines.push(data.title || "");
                    // lines.push('마감일 : 22-10-07 23:59')
                    lines.push("");
                    lines.push("");
                    data.qna.forEach(function(qna, idx) {
                        var _lines, _lines1;
                        // * 문항 제목
                        var questionLines = doc.splitTextToSize("".concat(idx + 1, ".").concat(qna.question || "문항 제목 없음"), 170);
                        (_lines = lines).push.apply(_lines, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(questionLines));
                        var answerLength = (0,_app_feature_coverletter_coverletter_write_libs_utils__WEBPACK_IMPORTED_MODULE_2__/* .getAnswerLength */ .t1)(qna.answer || "", qna.blankType, qna.charSize);
                        var blankType = (0,_app_feature_coverletter_coverletter_write_libs_utils__WEBPACK_IMPORTED_MODULE_2__/* .formatBlankType */ .St)(qna.blankType);
                        var charSize = (0,_app_feature_coverletter_coverletter_write_libs_utils__WEBPACK_IMPORTED_MODULE_2__/* .formatCharMaxSize */ .oD)(qna.charSize);
                        lines.push("".concat(answerLength, "/").concat(qna.charMaxSize, "(").concat(charSize, ", ").concat(blankType, ")"));
                        lines.push("");
                        // * 문항 답변
                        var answerLines = doc.splitTextToSize("".concat(qna.answer || "문항 내용 없음"), 170);
                        (_lines1 = lines).push.apply(_lines1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(answerLines));
                        lines.push("");
                    });
                    pages = getSplittedLines(lines, 50);
                    pages.forEach(function(pageLines, idx) {
                        if (idx !== 0) {
                            doc.addPage();
                        }
                        doc.text(pageLines, 20, 20);
                    });
                    return [
                        2,
                        doc
                    ];
            }
        });
    });
    return function formatSelfintroductionToJsPDF(data) {
        return _ref.apply(this, arguments);
    };
}();
var blobToBase64 = function(blob) {
    return new Promise(function(resolve) {
        var reader = new FileReader();
        reader.onloadend = function() {
            var ref;
            return resolve((ref = reader.result) === null || ref === void 0 ? void 0 : ref.slice(21));
        };
        reader.readAsDataURL(blob);
    });
};
var exportPdf = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(data) {
        var doc;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        formatSelfintroductionToJsPDF(data)
                    ];
                case 1:
                    doc = _state.sent();
                    doc.save("".concat(data.title, "_링커리어.pdf"));
                    return [
                        2
                    ];
            }
        });
    });
    return function exportPdf(data) {
        return _ref.apply(this, arguments);
    };
}();
var printPdf = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(data) {
        var // iframe.focus()
        ref, doc, docString, iframe;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        formatSelfintroductionToJsPDF(data)
                    ];
                case 1:
                    doc = _state.sent();
                    doc.autoPrint();
                    docString = doc.output("datauristring");
                    iframe = window.document.createElement("iframe");
                    iframe.setAttribute("src", docString);
                    iframe.setAttribute("style", "position: absolute; width: 1px; height: 1px;");
                    window.document.body.appendChild(iframe);
                    (ref = iframe.contentWindow) === null || ref === void 0 ? void 0 : ref.print();
                    return [
                        2
                    ];
            }
        });
    });
    return function printPdf(data) {
        return _ref.apply(this, arguments);
    };
}();
var exportDocx = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(data) {
        var textRunChildren, doc, blob;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    textRunChildren = formatSelfIntroductionToText(data).split("\n").map(function(line) {
                        return new docx__WEBPACK_IMPORTED_MODULE_0__.TextRun({
                            text: line,
                            break: 1
                        });
                    });
                    doc = new docx__WEBPACK_IMPORTED_MODULE_0__.Document({
                        sections: [
                            {
                                properties: {},
                                children: [
                                    new docx__WEBPACK_IMPORTED_MODULE_0__.Paragraph({
                                        children: textRunChildren
                                    })
                                ]
                            }
                        ]
                    });
                    return [
                        4,
                        docx__WEBPACK_IMPORTED_MODULE_0__.Packer.toBlob(doc)
                    ];
                case 1:
                    blob = _state.sent();
                    downloadBlob(blob, "".concat(data.title, "_링커리어.docx"));
                    return [
                        2
                    ];
            }
        });
    });
    return function exportDocx(data) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 63477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30132);
/* harmony import */ var app_styled_media__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68250);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: auto;\n  padding: 200px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  text-align: center;\n  .not-found-message {\n    color: #333;\n    font-weight: 500;\n    font-size: 20px;\n    margin-bottom: 10px;\n  }\n  .search-tip {\n    font-size: 16px;\n    color: #999;\n  }\n  ",
        " {\n    padding: 44px 0;\n    background-color: #fff;\n    border-bottom: 1px solid #e8e8e8;\n    .not-found-message {\n      font-size: 16px;\n    }\n    .search-tip {\n      font-size: 12px;\n      color: #999;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var SearchResultNotFound = function(param) {
    var searchKeyword = param.searchKeyword;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h4", {
                className: "not-found-message",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        style: {
                            color: "#01a0ff"
                        },
                        children: searchKeyword
                    }),
                    " 에 대한 검색결과가 없습니다."
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                className: "search-tip",
                children: [
                    "단어의 철자가 정확한지 확인하세요.",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    " 다른 검색어를 사용해보세요.",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    " 더 일반적인 검색어를 사용해 보세요."
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SearchResultNotFound);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SearchResultNotFound__StyledWrapper",
    componentId: "sc-609700f9-0"
})(_templateObject(), app_styled_media__WEBPACK_IMPORTED_MODULE_3__/* .mobileBreakPoint */ .vm);


/***/ }),

/***/ 6714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function assertIsNode(e) {
    if (!e || !("nodeType" in e)) {
        throw new Error("Node expected");
    }
}
var useDropdown = function() {
    var menuRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isDropdownOpened = ref[0], setIsDropdownOpened = ref[1];
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        return function() {
            window.removeEventListener("click", handleClick);
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    var handleClick = function(e) {
        if (!menuRef.current) return;
        assertIsNode(e.target);
        if (menuRef.current.contains(e.target) === false) {
            setIsDropdownOpened(false);
            window.removeEventListener("click", handleClick);
        }
    };
    var handleKeyDown = function(e) {
        if (!(e.key === "Enter") || !menuRef.current) return;
        assertIsNode(e.target);
        setIsDropdownOpened(false);
        window.removeEventListener("keydown", handleKeyDown);
        var targetInputName = e.target.name;
        var inputElement = document.querySelector('input[name="'.concat(targetInputName, '"]'));
        inputElement === null || inputElement === void 0 ? void 0 : inputElement.blur();
    };
    var toggleDropdown = function() {
        setIsDropdownOpened(function(prev) {
            return !prev;
        });
        window.removeEventListener("click", handleClick);
        window.addEventListener("click", handleClick);
        window.removeEventListener("keydown", handleKeyDown);
        window.addEventListener("keydown", handleKeyDown);
    };
    return [
        menuRef,
        isDropdownOpened,
        toggleDropdown
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (useDropdown);


/***/ }),

/***/ 14609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41120);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);



var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
    return {
        root: {
            display: "flex",
            gap: "10px",
            width: 110,
            height: 24,
            paddingTop: 12
        },
        ball: {
            width: 12,
            height: 12,
            display: "inline-block",
            float: "left",
            borderRadius: "50%",
            animation: "$delay 0.8s infinite ease-in-out",
            "&:nth-child(2)": {
                animationDelay: "-0.7s"
            },
            "&:nth-child(3)": {
                animationDelay: "-0.6s"
            },
            "&:nth-child(4)": {
                animationDelay: "-0.5s"
            },
            "&:nth-child(5)": {
                animationDelay: "-0.4s"
            }
        },
        "@keyframes delay": {
            "0%, 40%, 100%": {
                transform: "translateY(0)",
                backgroundColor: "#e1e1e1"
            },
            "20%": {
                transform: "translateY(-10px)",
                backgroundColor: "#888888"
            }
        }
    };
});
var BounceLoading = function(param) {
    var className = param.className;
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(classes.root, className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classes.ball
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classes.ball
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classes.ball
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classes.ball
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classes.ball
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BounceLoading);


/***/ }),

/***/ 17683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var keyword_highlighter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72423);
/* harmony import */ var keyword_highlighter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(keyword_highlighter__WEBPACK_IMPORTED_MODULE_1__);

// @ts-ignore

function useKeywordHighlighter(props) {
    var text = props.text, _keyword = props.keyword, keyword = _keyword === void 0 ? "" : _keyword;
    var highlightedText = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return keyword_highlighter__WEBPACK_IMPORTED_MODULE_1___default()(keyword, text);
    }, [
        text,
        keyword
    ]);
    return keyword ? highlightedText : text;
}
/* harmony default export */ __webpack_exports__["Z"] = (useKeywordHighlighter);


/***/ }),

/***/ 19468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useOutSideClick; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * @desc 검색 결과에 따라 리스트를 표시한 뒤 다른 영역을 클릭하거나 esc, tab 키를 입력시 리스트를 닫도록 합니다.
 *
 */ var useOutSideClick = function(param) {
    var ref = param.ref, onOutsideClick = param.onOutsideClick, isActive = param.isActive, _isDeferOutSideClick = param.isDeferOutSideClick, isDeferOutSideClick = _isDeferOutSideClick === void 0 ? false : _isDeferOutSideClick;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleMouseDown = function(e) {
            if (isActive && ref.current && !ref.current.contains(e.target)) {
                if (isDeferOutSideClick) {
                    setTimeout(function() {
                        onOutsideClick();
                    }, 0);
                } else {
                    onOutsideClick();
                }
            }
        };
        var handleKeyDown = function(e) {
            if (isActive && (e.code === "Escape" || e.code === "Tab")) {
                onOutsideClick();
            }
        };
        document.addEventListener("mousedown", handleMouseDown);
        document.addEventListener("keydown", handleKeyDown);
        return function() {
            document.removeEventListener("mousedown", handleMouseDown);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        isActive,
        onOutsideClick,
        ref
    ]);
};


/***/ }),

/***/ 57065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var CloseOutlined = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        width: "21",
        height: "21",
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "#999999",
            d: "M16.625 5.60875L15.3913 4.375L10.5 9.26625L5.60875 4.375L4.375 5.60875L9.26625 10.5L4.375 15.3913L5.60875 16.625L10.5 11.7337L15.3913 16.625L16.625 15.3913L11.7337 10.5L16.625 5.60875Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CloseOutlined);


/***/ }),

/***/ 12315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var Export = function(_param) {
    var _isActive = _param.isActive, isActive = _isActive === void 0 ? false : _isActive, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "isActive"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        "aria-label": "내보내기"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("desc", {
                children: "내보내기"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "none",
                d: "M0 0h20v20H0z",
                "data-name": "사각형 10787"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                "data-name": "그룹 10107",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "none",
                        stroke: isActive ? "#01a0ff" : "#333333",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2",
                        d: "M3 11.255v5.746h14v-5.746",
                        "data-name": "패스 8077"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        "data-name": "그룹 10105",
                        transform: "rotate(180 6.415 6.268)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "none",
                                stroke: isActive ? "#01a0ff" : "#333333",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: "2",
                                d: "M5.657 5.709L2.828 8.537 0 5.71",
                                "data-name": "패스 8078"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                width: "2",
                                height: "8",
                                fill: isActive ? "#01a0ff" : "#333333",
                                "data-name": "사각형 10886",
                                rx: "1",
                                transform: "translate(1.76)"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Export);


/***/ })

}]);